var _g;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgAmenityLounge = function SvgAmenityLounge(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#494949",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.429 35.819c0 .87-.701 1.574-1.57 1.574H6.14a1.57 1.57 0 0 1-1.569-1.574v-8.28h-1v8.28a2.57 2.57 0 0 0 2.57 2.574H26.86a2.57 2.57 0 0 0 2.569-2.574v-8.28h-1v8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.286 29.608c0 .87-.7 1.57-1.574 1.57H10.288a1.567 1.567 0 0 1-1.574-1.57v-5.18a.5.5 0 0 0-1 0v5.18a2.567 2.567 0 0 0 2.574 2.57h12.424a2.568 2.568 0 0 0 2.574-2.57v-5.18a.5.5 0 0 0-1 0v5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24.429a3.607 3.607 0 0 0-7.214 0 .5.5 0 1 0 1 0 2.607 2.607 0 1 1 2.607 2.607.5.5 0 0 0 0 1 3.607 3.607 0 0 0 3.607-3.607ZM2.5 24.429a2.607 2.607 0 0 1 5.214 0 .5.5 0 1 0 1 0 3.607 3.607 0 1 0-3.607 3.607.5.5 0 1 0 0-1A2.607 2.607 0 0 1 2.5 24.429ZM25.84 40.482a.5.5 0 0 0 1 0v-2.071a.5.5 0 1 0-1 0v2.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.607 20.37v-.602c0-3.835 4.018-7.268 10.893-7.268 6.872 0 10.893 3.437 10.893 7.268v1.036a.5.5 0 0 0 1 0v-1.036c0-4.42-4.5-8.268-11.893-8.268-7.395 0-11.893 3.843-11.893 8.268v1.204a.5.5 0 0 0 1 0v-.602ZM7.196 40.482a.5.5 0 0 0 1 0v-2.071a.5.5 0 1 0-1 0v2.071ZM24.3 26.988c-.512-.138-1.1-.275-1.759-.403-4.503-.878-9.491-.878-14.468.586a.5.5 0 0 0 .282.96c4.805-1.414 9.637-1.414 13.995-.565.634.124 1.2.256 1.69.388.29.078.489.138.588.171a.5.5 0 1 0 .316-.949 12.543 12.543 0 0 0-.644-.188Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 28.15V40.5M34.514 20.821h3.638l-.786 5.165h-1.991zM36.5 20.821l1-2.321M33 26h13v2H33zM37.5 40.5h4",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

export { SvgAmenityLounge as ReactComponent };
export default "/_next/static/media/amenity_lounge.72678e5f.svg";